import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class WalletDetails extends Model {
  @Expose()
  id: number;

  @Expose()
  balance: number;

  @Expose()
  totalCredit: number;

  @Expose()
  totalDebit: number;

  @Expose()
  currency: string;

  @Expose()
  isEnabled: boolean;

  @Expose()
  iban: string;
}
